import React from 'react'
import { Modal } from 'react-bootstrap'

export default class modalLoading extends React.Component {
    render() {
        const { showModalLoad, CancelHandler, DeleteHandler2, Model } = this.props

        return (
            <div>
                <Modal show={showModalLoad} onHide={CancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>CEK KETERSEDIAAN JADWAL</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Mohon menunggu, kami sedang mengecek waktu ketersediaan konsultasi <br /> <br />
                        </p>
                        <div class="text-center">
                            <div class="spinner-border text-primary text-center" style={{ width: 100, height: 100 }} role="status">
                                <span class="visually-hidden"></span>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>



                    </Modal.Footer>
                </Modal>

            </div>
        )
    }
}